import React, { useCallback, useEffect, useState } from "react";
import { Translate } from "react-localize-redux";
import { useProject } from "../../utils/hooks/useProject";
import API from "../../utils/API";
import Loading from "../../utils/components/Loading";
import DefaultReport from "./DefaultReport";
import { getEnv } from "../../utils/env";

const Reports = ({ translate }) => {
  const { project } = useProject();

  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(undefined);

  const getUserReport = useCallback(() => {
    if (!project?.id) return;

    setLoading(true);
    API.getData(`/user_project_report/${project.id}`)
      .then(({ data: res }) => {
        setLink(res?.data?.link ?? null);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project?.id]);

  useEffect(() => {
    getUserReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project?.id]);

  if (loading) return <Loading/>;

  if (!project?.id) return <Translate id="select_a_project_alert"/>;

  if (link === null && getEnv("REACT_APP_ENABLE_DEFAULT_REPORT") === "true") {
    return <DefaultReport translate={translate} />;
  } else {
    return (
      <iframe
        src={link}
        allowFullScreen
        frame="0"
        width="100%"
        height="100%"
        rel="noopener noreferrer"
        title="Report"
        className="vh-100"
      >
        Your reports are not created yet.
      </iframe>
    );
  }
};

export default Reports;
